import { useEffect, useRef, useState } from 'react';
import Race from '../race/race';
import { BlindKaizoRace } from '../../../../../types/raceTypes';

interface LazyRaceProps {
	race: BlindKaizoRace
	raceFilePath: string
	/** When true, render the race immediately so it exists for deep-link scroll (see focusRace). */
	forceMount?: boolean
}

export default function LazyRace({ race, raceFilePath, forceMount = false }: LazyRaceProps) {
	const [hasBeenVisible, setHasBeenVisible] = useState(forceMount);
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setHasBeenVisible(true);
					}
				});
			},
			{
				rootMargin: '200px'
			}
		);

		const currentRef = containerRef.current;
		if (currentRef) {
			observer.observe(currentRef);
		}

		return () => {
			if (currentRef) {
				observer.unobserve(currentRef);
			}
		};
	}, []);

	useEffect(() => {
		if (forceMount) {
			setHasBeenVisible(true);
		}
	}, [forceMount]);

	return (
		<div ref={containerRef} style={{ minHeight: hasBeenVisible ? 'auto' : '436px' }}>
			{hasBeenVisible && <Race race={race} raceFilePath={raceFilePath} />}
		</div>
	);
}









